export default {
    name: "organizations",
    component: () => import(/* auth-router-module */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: "",
            name: "organizations-index",
            meta: {
                breadcrumbs: [],
                title: "Organizations"
            },
            component: () => import('@/modules/organizations/views/Index.vue')
        }
    ]
}